import { DayLabel, Text } from '@shared/components'
import { Col, Flex, Row, Space } from 'antd'
import { useTranslation } from 'react-i18next'

import { CompleteTaskButton } from '../ExtraComponents'
import { ActivityLogAvatar } from './ActivityLogAvatar'
import { ActivityLogProps } from './types'
import { useGetTranslatedDescription } from './useGetTranslatedDescription'

export const ActivityLogTask = ({ log }: ActivityLogProps) => {
  const { t } = useTranslation()
  const translatedDescription = useGetTranslatedDescription({ log })

  return (
    <Row justify="space-between" gutter={[16, 16]} align="middle">
      <Col xs={24} xl={12} xxl={12}>
        <Text isEllipsis>{translatedDescription}</Text>
      </Col>

      <Col xs={24} xl={12} xxl={12}>
        <Flex gap={12} wrap justify="end">
          <Flex vertical gap={8} justify="end">
            {log?.task?.owner && (
              <ActivityLogAvatar
                user={log?.task?.owner}
                label={t('task.owner')}
              />
            )}

            {log?.created_by && (
              <ActivityLogAvatar
                user={log?.created_by}
                label={t('task.created_by')}
              />
            )}
          </Flex>

          <Flex vertical gap={8} justify="end">
            <Space.Compact className="w-full">
              <CompleteTaskButton log={log} />
            </Space.Compact>

            <DayLabel date={log.created_at} />
          </Flex>
        </Flex>
      </Col>
    </Row>
  )
}
